import { appstr } from "@coreapp/utils/appstr";
import { Button, ButtonProps } from "@theorgchartdev/storybook";
import { useToolbarButtonTooltip } from "./useToolbarButtonTooltip";
import { useTableInstanceContext } from "@/providers/PlanningTabularProvider";

interface ReleaseEmployeeProps extends ButtonProps {}

export const ReleaseEmployee = (props: ReleaseEmployeeProps) => {
  const { selectedPositionsCount, isClosedOrUnassignedPositionsSelected } =
    useTableInstanceContext();

  const noPositionSelected = selectedPositionsCount === 0;
  const closedOrUnassignedPositionsSelected = isClosedOrUnassignedPositionsSelected();
  const isDisabled = noPositionSelected || closedOrUnassignedPositionsSelected;

  const tooltipProps = useToolbarButtonTooltip("release");

  return (
    <Button
      {...props}
      disabled={isDisabled}
      iconProps={{
        name: "user-xmark",
        title: "user-xmark"
      }}
      modifier="secondary"
      tooltipProps={tooltipProps}
    >
      {appstr("Release")}
    </Button>
  );
};
